import { EnglishArabicDTO } from "bbsf-controls"
export class DepartmentModel
{
  Id: number
  SectorId?: number
  IDEncrypted: string
  DepartmentNameDTO: EnglishArabicDTO = new EnglishArabicDTO();
  DepartmentName: string;
  SectorName: string;
  UsersCount: number
  SamAccount: string
}
